import { MatchingFilter } from './../model/matching-filter.model';
import { filter } from 'rxjs/operators';
import { Injectable, OnDestroy } from '@angular/core';
import { HttpHeaderService } from 'src/app/shared/service/http-header.service';
import { HttpClient } from '@angular/common/http';
import { HttpClientAbstract } from 'src/app/shared/service/http-client-abstract';
import { Observable, Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class MatchingFilterService extends HttpClientAbstract implements OnDestroy {
  private subscriptions: Subscription = new Subscription();

  constructor(
    header: HttpHeaderService,
    http: HttpClient,
    private toastrService: ToastrService
  ) {
    super(header, http);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  public getMatchingFilters(): Observable<any> {
    return super.requestGet('api/v1/matching_filters');
  }

  public updateMatchingFilter(matchingFilter: MatchingFilter): Observable<any> {
    return super.requestPost('api/v1/matching_filters/update', matchingFilter);
  }

  // 当座はOKの項目は設定変更できないように対応
  public switchOk(matchingFilter: MatchingFilter): void {
    this.toastrService.info('この項目は変更できません。');
    // matchingFilter.ok = !matchingFilter.ok;
    // this.updateFilter(matchingFilter);
  }

  public switchNg(matchingFilter: MatchingFilter): void {
    matchingFilter.ng = !matchingFilter.ng;
    this.updateFilter(matchingFilter);
  }

  public switchUnk(matchingFilter: MatchingFilter): void {
    matchingFilter.unk = !matchingFilter.unk;
    this.updateFilter(matchingFilter);
  }

  private updateFilter(matchingFilter: MatchingFilter): void {
    const updateSub = this.updateMatchingFilter(matchingFilter).subscribe(
      res => {
        matchingFilter = res.body.matching_filter;
        this.toastrService.success('設定を変更しました。');
      },
      err => {
        this.toastrService.error('設定の変更に失敗しました。');
      }
    );
    this.subscriptions.add(updateSub);
  }
}
